import { render, staticRenderFns } from "./partialFooter.vue?vue&type=template&id=4987ac3e&scoped=true&"
import script from "./partialFooter.vue?vue&type=script&lang=js&"
export * from "./partialFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4987ac3e",
  null
  
)

export default component.exports